import { ClientContact, CreateApprovalReviewer } from '@abovo/shared-models';
import { ReviewerRoleSlugs, ReviewerStatusSlugs } from '../constants/approval-request.constants';

export function constructApprovalReviewer(contact: ClientContact, roleSlug: ReviewerRoleSlugs): CreateApprovalReviewer {
   return {
      user: {
         id: contact.user_id,
         first_name: contact.first_name,
         last_name: contact.last_name,
      },
      role_type: { slug: roleSlug },
      status: { slug: ReviewerStatusSlugs.pending },
   };
}
